import React from "react";
import { Card } from "./TvBits";

const Pick = ({ r, color, testid }) => (
  <div className="flex items-center gap-4 py-2 border-b border-white/5" data-testid={testid}>
    <b className="nx-orbitron text-[clamp(1.6rem,2.6vw,2.8rem)] font-black w-[22%] shrink-0" style={{ color, textShadow: `0 0 18px ${color}66` }}>{r.ticker}</b>
    <span className="flex-1 text-[clamp(0.9rem,1.1vw,1.25rem)] text-cyan-50/90 leading-snug line-clamp-2">{r.reason}</span>
    <span className="nx-mono text-[clamp(1.1rem,1.6vw,1.8rem)] font-black w-16 text-right" style={{ color }}>{r.conviction}</span>
  </div>
);

const Col = ({ title, rows, color, testid }) => (
  <Card title={title} accent={color} code="CONVICTION 0-100" className="h-full" testid={testid}>
    {rows?.length ? rows.slice(0, 7).map((r, i) => <Pick key={r.ticker + i} r={r} color={color} testid={`${testid}-row`} />)
      : <p className="nx-mono text-cyan-200/40 tracking-widest">NONE TODAY</p>}
  </Card>
);

const News = ({ title, items, color, testid }) => (
  <Card title={title} accent={color} className="h-full" testid={testid}>
    <div className="space-y-1.5">{(items || []).slice(0, 5).map((t, i) => <p key={i} className="text-base text-cyan-50/90 leading-snug border-l-2 pl-2" style={{ borderColor: color }}>{t}</p>)}</div>
  </Card>
);

export const TvVideoDigest = ({ d }) => {
  const g = d.video_digest;
  if (!g) return null;
  const date = new Date(`${g.date}T12:00:00`).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
  return (
    <div className="h-full flex flex-col gap-4" data-testid="tv-scene-digest">
      <div className="flex items-baseline gap-4 shrink-0">
        <p className="nx-orbitron text-[clamp(1.4rem,2.2vw,2.4rem)] font-black tracking-[0.25em] text-[#00F0FF]" style={{ textShadow: "0 0 20px #00F0FF66" }}>VIDEO DIGEST</p>
        <p className="nx-mono text-lg tracking-widest text-cyan-200/70" data-testid="tv-digest-date">{date.toUpperCase()} · {g.video_count} VIDEOS · LAST {g.window_hours || 24}H</p>
      </div>
      <div className="grid grid-cols-2 gap-4 flex-[3] min-h-0">
        <Col title="BUY" rows={g.stocks_to_buy} color="#10B981" testid="tv-digest-buy" />
        <Col title="AVOID" rows={g.stocks_to_avoid} color="#EF4444" testid="tv-digest-avoid" />
      </div>
      <div className="grid grid-cols-2 gap-4 flex-[1.3] min-h-0">
        <News title="ALARMING" items={g.alarming_news} color="#F97316" testid="tv-digest-alarming" />
        <News title="GOOD NEWS" items={g.good_news} color="#22D3EE" testid="tv-digest-good" />
      </div>
    </div>
  );
};
